/* eslint-disable @typescript-eslint/no-unused-vars */
import { useMutation } from '@tanstack/react-query';
import _ from 'lodash';
import { useState } from 'react';
import { RETMSignInAPI } from '../../../api/retm.api';
import './index.scss';
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CFooter,
  CFormInput,
  CImage,
  CInputGroup,
  CInputGroupText,
  CRow,
} from '@coreui/react-pro';
import CIcon from '@coreui/icons-react';
import appStore from '../../../assets/stores/app-store.svg';
import googlePlay from '../../../assets/stores/google-play.svg';
import headerLogo from './bbookLogo.png';
import blogo from './phone.png';
import retmLogo from './retmlogo.svg';
import { cilPhone, cilLockLocked } from '@coreui/icons';
import { useFormik } from 'formik';
import { CardHeader } from 'react-bootstrap';
import env from '../../../env';
import SignInFormCheck from './formCheck';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import UseToast from '../../../hooks/useToast';
import OtpScreen from './OTP';
const RETM_Login = () => {
  const [country_code, setcountry_code] = useState('+966');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [iconShow, setIconShow] = useState<boolean>(false);
  const [showOTP, setShowOTP] = useState<boolean>(false);

  const packageName = 'com.beautybook.customer';
  const appleId = '6450213994';

  const appStoreLink = `itms-apps://itunes.apple.com/app/id${appleId}`;
  const playStoreLink = `market://details?id=${packageName}`;

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = _.get(e, 'target.value');
    const id = _.get(e, 'target.id');

    if (value !== ' ') {
      if (
        (id === 'contactNumber' && value.length === 10) ??
        (id === 'password' && value.length === 17)
      ) {
        return null;
      } else {
        setFieldValue(id, value);
      }
    }
  };

  const { mutate, isLoading } = useMutation(RETMSignInAPI, {
    onSuccess: (data) => {
      setShowOTP(true);
      UseToast('Verification code has been sent - تم إرسال رمز التحقق', 'success');
    },
    onError: (data: any) => {
      const ErrMsg = data?.data?.message;
      console.log(ErrMsg, 'ErrMsgErrMsg');
    },
  });

  const { handleSubmit, values, handleChange, handleBlur, errors, touched, setFieldValue } =
    useFormik({
      validationSchema: SignInFormCheck,
      initialValues: {
        email: '',
        password: '',
        countryPrefix: country_code,
        contactNumber: '',
      },
      enableReinitialize: true,
      onSubmit: async (values) => {
        // eslint-disable-next-line no-restricted-globals
        event?.preventDefault();

        mutate({
          ...values,
        });
      },
    });

  return (
    <>
      <title>Daif - RETM</title>
      <CCard style={{ minHeight: '80dvh' }}>
        <CardHeader className="booking-header">
          <div className="booking-logo">
            <CImage
              width={'200px'}
              height={'150px'}
              align="start"
              alt="logo"
              src={headerLogo}
              className="profile-picture"
            />
            <span style={{ marginLeft: '20px', marginRight: '20px' }}>|</span>
            <CImage
              width={'50px'}
              height={'50px'}
              align="start"
              alt="logo"
              src={retmLogo}
              className="profile-picture"
            />

            <span className="retm"> RETM </span>
          </div>
        </CardHeader>
        <CCardBody style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          {showOTP ? (
            <OtpScreen
              contactNumber={values.contactNumber}
              countryPrefix={values.countryPrefix}
              password={values.password}
            />
          ) : (
            <div>
              <CRow className="justify-content-center mb-4">
                <CCol xs="6" lg="6">
                  <CImage width={'200px'} height={'240px'} align="center" alt="logo" src={blogo} />
                </CCol>
              </CRow>
              <CRow className="justify-content-center mb-4">
                <CCol xs="12" lg="3">
                  <h6 className="mb-4" style={{ color: '#353535' }}>
                    Already using RETM? Seamlessly migrate your data to Bbook.
                    <br />
                    RETM is a powerful integrated point-of-sale system trusted by many businesses.
                    <br />
                    If you are currently using RETM, you can easily transfer your data to Bbook
                    without losing a step.
                  </h6>
                  <h6 className="mb-4 text-right" style={{ color: '#353535' }}>
                    هل تستخدم نظام رتم ؟ يمكنك نقل بياناتك بسهولة إلى بيبوك
                    <br />
                    يُعد نظام رتم من أفضل أنظمة نقاط البيع المتكاملة، ويعتمد عليه العديد من أصحاب
                    الأعمال
                    <br />
                    إذا كنت تستخدم رتم حاليًا، يمكنك نقل بياناتك بسهولة إلى بيبوك دون أي تعقيدات
                  </h6>
                </CCol>
              </CRow>

              <CRow className="justify-content-center">
                <CCol xs="3" lg="3" className="text-end">
                  Contact Number
                </CCol>
                <CCol xs="6" lg="3">
                  <CInputGroup className="mb-3 contact-div">
                    <CInputGroupText className="iconSize">
                      <CIcon icon={cilPhone} />
                    </CInputGroupText>
                    <CInputGroupText className="iconSize">{country_code}</CInputGroupText>

                    <CFormInput
                      type="number"
                      min={0}
                      placeholder="5555555555"
                      autoComplete="contactNumber"
                      id="contactNumber"
                      value={values.contactNumber}
                      onChange={handleOnChange}
                      onBlur={handleBlur}
                      invalid={touched.contactNumber && Boolean(errors.contactNumber)}
                      feedback={
                        touched.contactNumber &&
                        Boolean(errors.contactNumber) &&
                        errors.contactNumber
                      }
                      onWheel={(e) => e.currentTarget.blur()}
                      onKeyDown={(e) => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()}
                    />
                  </CInputGroup>
                </CCol>
                <CCol xs="3" lg="3">
                  رقم الجوال
                </CCol>
              </CRow>
              <CRow className="justify-content-center">
                <CCol xs="3" lg="3" className="text-end">
                  Password
                </CCol>
                <CCol xs="6" lg="3">
                  <CInputGroup className="wid-75" style={{ userSelect: 'none' }}>
                    <CInputGroupText>
                      <CIcon icon={cilLockLocked} />
                    </CInputGroupText>

                    <CFormInput
                      onPaste={(e: any) => {
                        if (env.env != 'local') {
                          e.preventDefault();
                          return false;
                        }
                      }}
                      type={iconShow ? 'text' : 'password'}
                      maxLength={16}
                      placeholder="**************"
                      autoComplete="password"
                      id="password"
                      onBlur={handleBlur}
                      value={values.password}
                      invalid={touched.password && Boolean(errors.password)}
                      onChange={(e) => handleOnChange(e)}
                      disabled={isLoading}
                      autoFocus={false}
                      capture={false}
                    />
                    <CInputGroupText
                      onClick={() =>
                        setIconShow((prevState) => {
                          return !prevState;
                        })
                      }
                    >
                      {iconShow ? <AiFillEye /> : <AiFillEyeInvisible />}
                    </CInputGroupText>
                    <p className="text-danger f-25">
                      {touched.password && Boolean(errors.password) && errors.password}
                    </p>
                  </CInputGroup>
                </CCol>
                <CCol xs="3" lg="3">
                  كلمة المرور
                </CCol>
              </CRow>

              <CRow className="justify-content-center">
                <CCol xs="12" lg="12" className="text-center mt-4">
                  <CButton
                    color="primary"
                    className="px-4"
                    onClick={() => handleSubmit()}
                    disabled={isLoading}
                  >
                    Sign In | تسجيل الدخول
                  </CButton>
                </CCol>
              </CRow>
            </div>
          )}
        </CCardBody>
      </CCard>

      <CFooter className="booking-footer">
        <div style={{ width: '100%' }}>
          <CRow className="justify-content-center align-items-center pb-5">
            <CCol xs="auto">
              <a href={appStoreLink} className="text-white mr-4">
                <img
                  src={appStore}
                  alt="appStore"
                  style={{ maxWidth: '150px', maxHeight: '50px' }}
                />
              </a>
            </CCol>
            <CCol xs="auto">
              <a href={playStoreLink} className="text-white">
                <img
                  src={googlePlay}
                  alt="googlePlay"
                  style={{ maxWidth: '150px', maxHeight: '50px' }}
                />
              </a>
            </CCol>
          </CRow>
        </div>
      </CFooter>
    </>
  );
};

export default RETM_Login;
